import { formatDateToCodeReadable } from '../dateTimeUtil';

export const humanReadableDateSort = (dateA: string, dateB: string) => {
    const codeReadableDateA = formatDateToCodeReadable(dateA);
    const codeReadableDateB = formatDateToCodeReadable(dateB);

    if (codeReadableDateA === codeReadableDateB) return 0;

    return codeReadableDateA > codeReadableDateB ? 1 : -1;
};

export const dateFilterComparator = (filterLocalDateAtMidnight: Date, dateAsString: string) => {
    if (dateAsString == null) {
        return 0;
    }

    // dates are stored as yyyy-dd-mm
    const dateParts = dateAsString.split('-');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);

    if (cellDate < filterLocalDateAtMidnight) {
        return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
        return 1;
    }
    return 0;
};

export const dateComparator = (date1: string | null | undefined, date2: string | null | undefined) => {
    const date1Number = YYYYMMDDStrToNum(date1);
    const date2Number = YYYYMMDDStrToNum(date2);

    if (date1Number === null && date2Number === null) {
        return 0;
    }
    if (date1Number === null) {
        return -1;
    }
    if (date2Number === null) {
        return 1;
    }

    return date1Number - date2Number;
};

const YYYYMMDDStrToNum = (date: string | null | undefined) => {
    if (date === undefined || date === null || date.length !== 10) {
        return null;
    }

    const yearNumber = Number(date.substring(0, 4));
    const monthNumber = Number(date.substring(5, 7));
    const dayNumber = Number(date.substring(8, 10));

    const result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    // 2004-08-29 => 20040829
    return result;
};
